<template>
  <div id="dropzone-container">
    <section>
        <b-tabs type="is-boxed">
            <b-tab-item label="Mis imágenes" icon="folder">
              <div id="gallery">
                <div v-for="image in listOfFiles" :key="image.file"  class="image-item-container">
                    <!-- <span class = "material-icons md-24 deleteicon" @click.stop="deletefile(image)"> delete</span> -->
                    <b-dropdown class="project-menu is-right"  style="position:absolute; top:0px; right:0px;">
                      <a slot="trigger"> <b-icon icon="dots-vertical"></b-icon> </a>
                      <b-dropdown-item  @click="copyToClipboard(image.file)"> Copiar url</b-dropdown-item>
                      <b-dropdown-item @click="deletefile(image)">Borrar imagen</b-dropdown-item>
                    </b-dropdown>
                  <div @click="copyToClipboard(image.file)" class="image-item" :style="'background-image:url('+image.file+')'">
                    <div style="text-align:center"> <span class = "material-icons md-24 copyicon">file_copy</span>
                    </div>
                  </div>
                </div>
              </div>
              <p class="is-size-7"> Para trabajar con imágenes evita enlazarlas desde otros servidores. Súbelas aquí.
              <br/> Haz click sobre la imagen para copiar su URL y pégala luego en el editor donde la necesites.
              </p>
            </b-tab-item>
            <b-tab-item label="Subir nuevas imágenes" icon= "upload">
              <p> NOTA: Las imágenes que subas son públicas. Máximo 100kb por imagen. </p>
                <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" v-on:vdropzone-success="fetchUserFiles"></vue-dropzone>
            </b-tab-item>
        </b-tabs>
      </section>
  </div>
</template>
<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import config from '../../api/config'
export default {
  name: 'uploadFile',
  components: {
    vueDropzone: vue2Dropzone
  },
  data: function () {
    return {
      dropzoneOptions: {
        url: config.baseurl + '/uploadedfiles/',
        thumbnailWidth: 150,
        method: 'post',
        maxFilesize: 0.1,
        headers: { 'Authorization': 'Token ' + this.$store.state.auth.token }
      },
      listOfFiles: []
    }
  },
  methods: {
    copyToClipboard (str) {
      var parser = document.createElement('a')
      parser.href = str

      // eslint-disable-next-line
      let relativeURL = parser.pathname
      const el = document.createElement('textarea')
      el.value = relativeURL
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.$toast.open({
        message: 'Url copiada al portapapeles: ' + relativeURL,
        duration: 4000
      })
      this.$parent.close()
    },
    fetchUserFiles () {
      this.$store.dispatch('user/fetchUserFiles')
        .then(response => {
          console.log('response')
          console.log(response.data)
          this.listOfFiles = response.data
        }).catch((error) => {
          console.log('fetchUserFiles', 'FAIL', error)
        })
    },
    deletefile (file) {
      this.$store.dispatch('user/deleteUserFile', file.id)
        .then(d => {
          this.fetchUserFiles()
        })
      return true
    }
  },
  created () {
    this.fetchUserFiles()
  }
}
/*
const config = {
  headers: { 'Content-Type': 'multipart/form-data' }
}
return Vue.axios.patch(REST_URL + '/users/' + context.rootState.auth.userid + '/', data, config).then(response => {
  console.log(response.data)
})
*/
</script>
<style lang="less" scoped>

#dropzone-container{
  background:white;
  min-height:300px;
}

#gallery{
    display: flex;
    flex-wrap: wrap;
    max-height: 400px;
    overflow-y: auto;
    padding-left: 2em;
    .image-item-container{
      margin: 1em;
      position: relative
    }
    .image-item{
      width:100px;
      height:100px;
      background-size: contain;
      background-repeat: no-repeat;
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      cursor: pointer;
      text-align: right;
      &:hover{
        border:2px #eaeaea solid;
      }
    }
    .copyicon{
      color: rgba(0,0,0,0.8);
      background-color: white;
      padding: 8px;
      border-radius: 8px;
      margin-top:30%
    }
    .deleteicon{
      color: rgba(0,0,0,0.2);
    }
    .deleteicon:hover{
      color:red;
    }

    .dropdown-trigger>a>span{
      background-color: rgba(255,255,255,0.2);
      color:black;
      padding:0px;
    }
    .dropdown-menu .dropdown-item{
      display: block;
      text-align: right;
      padding:8px 16px ;
    }

    .image-item{
      a,span{
        display: none;
      }
    }
    .image-item:hover{
      a,span{
        display: inline-block;
      }
    }
    .tab-content{
      max-height: 400px;
      overflow: auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/UI/uploadFile.vue